// extracted by mini-css-extract-plugin
module.exports = {"video":"petunjuk_video__GYF8R","container":"petunjuk_container__3GY2_","root":"petunjuk_root__3wFZz","bar":"petunjuk_bar__2x2bO"};